var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ma-1 pr-4",attrs:{"color":_vm.color ? _vm.color : _vm.M_WARNA[_vm.colorIdx || 0],"small":""}},[(_vm.chip.icon)?_c('v-avatar',[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.chip.icon))])],1):_vm._e(),_vm._v(" "+_vm._s(_vm.chip.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }